// Author Lin
// Date 2021-11-03 10:33:20

class MintalMesPrdSmeltingDrillParameter {
    constructor({
            id = null,
            slagIronId = '',
            depth = '',
            mudName = '',
            mudNumber = '',
            drillTubeNumber = '',
            otherTubeNumber = '',
            slagStatus = '',
            recorderId = '',
            reviewerId = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.slagIronId = slagIronId;
        this.depth = depth;
        this.mudName = mudName;
        this.mudNumber = mudNumber;
        this.drillTubeNumber = drillTubeNumber;
        this.otherTubeNumber = otherTubeNumber;
        this.slagStatus = slagStatus;
        this.recorderId = recorderId;
        this.reviewerId = reviewerId;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesPrdSmeltingDrillParameter();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'slagIronId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.slagIronId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'startTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.startTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'dischargeTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.dischargeTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'depth',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.depth',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'mudName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.mudName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'mudNumber',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.mudNumber',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'drillTubeNumber',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.drillTubeNumber',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'otherTubeNumber',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.otherTubeNumber',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'slagStatus',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.slagStatus',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recorderId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.recorderId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recorder',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.recorder',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewerId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.reviewerId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewer',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.reviewer',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        slagIronIdFilter : '',
        depthFilter : '',
        mudNameFilter : '',
        mudNumberFilter : '',
        drillTubeNumberFilter : '',
        otherTubeNumberFilter : '',
        slagStatusFilter : '',
        recorderIdFilter : '',
        reviewerIdFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'slagIronIdFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.filter.slagIronId',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesPrdSmeltingSlagIron'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'mudNameFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.filter.mudName',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'recorderIdFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.filter.recorderId',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'reviewerIdFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.filter.reviewerId',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            }
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'slagIronId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.slagIronId',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesPrdSmeltingSlagIron'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'depth',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.depth',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'mudName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.mudName',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'mudNumber',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.mudNumber',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'drillTubeNumber',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.drillTubeNumber',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'otherTubeNumber',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.otherTubeNumber',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'slagStatus',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.slagStatus',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'recorderId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.recorderId',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'reviewerId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.reviewerId',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdSmeltingDrillParameter.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesPrdSmeltingDrillParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    